import { Stack, TextField, Button, InputAdornment } from '@mui/material';
import { signInWithPhoneNumber, getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import Alert from '@mui/material/Alert';
import { useState } from 'react';

import Recaptcha from '../components/Recaptcha';
import { useHistory } from 'react-router';
import { setError } from '../services/Errors';

const SmsLogin = () => {
    const [loginObj, setLoginObj] = useState(null);
    const [phoneAlert, setPhoneAlert] = useState({ open: false });
    const [codeAlert, setCodeAlert] = useState({ open: false });

    const auth = getAuth();
    const history = useHistory();

    const sendCode = (phoneNumber) => {
        const appVerifier = window.recaptchaVerifier;
        setPersistence(auth, browserLocalPersistence).then(() =>
            signInWithPhoneNumber(auth, phoneNumber, appVerifier)
                .then((confirmationResult) => {
                    window.confirmationResult = confirmationResult;
                    setPhoneAlert({
                        open: true,
                        type: 'success',
                        message: 'SMS sendt! 👏 Sjekk mobilen din og fyll inn koden nedenfor.',
                    });
                })
                .catch((error) => {
                    setPhoneAlert({ open: true, type: 'error', message: 'Oops! Kunne ikke sende SMS 😓' });
                    setError(phoneNumber, error.message);
                })
                .catch((error) => {
                    setPhoneAlert({ open: true, type: 'error', message: 'Oops! Det har skjedd en feil 😓' });
                    setError(phoneNumber, error.message);
                })
        );
    };

    const verifyCode = (code) => {
        window.confirmationResult
            .confirm(code)
            .then((result) => {
                setCodeAlert({ open: true, type: 'success', message: 'Du er nå logget inn!' });
                history.push('./');
            })
            .catch((error) => {
                setCodeAlert({ open: true, type: 'error', message: 'Oops! Kunne verifisere koden. 😭 Har du skrevet riktig?' });
                setError('unknown', error.message);
            });
    };

    return (
        <>
            <Stack spacing={2} mt={3}>
                <TextField
                    variant="outlined"
                    label="Telefonnummer"
                    type="string"
                    inputProps={{
                        maxLength: 8,
                    }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">+47</InputAdornment>,
                    }}
                    onChange={({ target }) => setLoginObj({ ...loginObj, phoneNumber: '+47' + target.value })}
                />
                {!phoneAlert.open && <Recaptcha />}
                <Button
                    onClick={() => sendCode(loginObj?.phoneNumber)}
                    sx={{ maxWidth: '140px' }}
                    variant="contained"
                    color="primary"
                >
                    Send sms
                </Button>
                {phoneAlert.open && <Alert severity={phoneAlert.type}>{phoneAlert.message}</Alert>}
            </Stack>
            {phoneAlert.open && (
                <Stack spacing={2} mt={3}>
                    <TextField
                        variant="outlined"
                        label="Kode"
                        type="string"
                        inputProps={{
                            maxLength: 6,
                        }}
                        onChange={({ target }) => setLoginObj({ ...loginObj, code: target.value })}
                    />
                    <Button onClick={() => verifyCode(loginObj.code)} sx={{ maxWidth: '140px' }} variant="contained" color="primary">
                        Valider sms
                    </Button>
                    {codeAlert.open && <Alert severity={codeAlert.type}>{codeAlert.message}</Alert>}
                </Stack>
            )}
        </>
    );
};

export default SmsLogin;
